<template>
    <div class="form-default">
        <h2 class="title-form" :style="{color : colors.theme == 'dark' ? '#fff' : '#000'}">{{ title }}</h2>
        <div class="form">
            <input 
                v-for="(label, index) in labels" 
                :id="label.name"
                :type="label.type" 
                class="input-form"
                :key="index"
                :placeholder="label.placeholder"
                @input="verifyForm()">
        </div>
    </div>
</template>
<script>
import { Bus } from '../../../event-bus.js'
export default {
    data: function(){
        return{
            colors: {}
        }
    },
    props: {
        title : {
            type : String,
            required : true
        },
        labels : {
            type : Array,
            required : true
        }
    },
    created(){
        Bus.$emit('ableButton')
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    methods : {
        verifyForm(){
            let inputs = document.querySelectorAll('.input-form')
            let inputVazio = 0
            inputs.forEach((input,index) => {
                if(input.value == ''){
                    if(telefone){
                        return
                    }
                    inputVazio = inputVazio + 1
                }
            })
            if(inputVazio == 0){
                Bus.$emit('ableButton')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .form-default{
        display: flex;
        flex-direction: column;
        align-items: center;

        .title-form{
            // color : #85007c;
            font-size: 12px;
            letter-spacing: 2px;
            text-transform: uppercase;
            font-weight: bold;
            margin: 30px 0;
            padding: 0 25px;
        }

        .form{

            display: flex;
            flex-direction: column;
            width: 85%;

            .input-form{

                margin: 2% auto;
                width: 100%;
                max-width: 500px;
                border-radius: 5px;
                border: none;
                padding: 13px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: none;
                // color: #85007c;
                font-weight: bold;

                &::placeholder{
                    color : #000;
                    font-weight: 600;
                }
            }
        }
    }
</style>
